import type { ButtonHTMLAttributes } from "react";
import { buttonClass, type ButtonOptions } from "./classes";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & ButtonOptions;

export const Button = ({
  variant,
  size,
  destructive,
  fullWidth,
  pill,
  className = "",
  type = "button",
  ...props
}: ButtonProps) => (
  <button
    type={type}
    className={`${buttonClass({ variant, size, destructive, fullWidth, pill })} ${className}`}
    {...props}
  />
);

/** A square button showing only an icon; `aria-label` is required. */
export const IconButton = ({
  size = "md",
  className = "",
  type = "button",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  "aria-label": string;
  size?: "sm" | "md";
}) => (
  <button
    type={type}
    className={`grid shrink-0 place-items-center rounded-lg text-hazumu-muted transition-colors hover:bg-hazumu-canvas hover:text-hazumu-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-hazumu-ink disabled:pointer-events-none disabled:opacity-40 ${size === "sm" ? "size-8" : "size-9"} ${className}`}
    {...props}
  />
);
